import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    '&.Mui-checked:not(.Mui-disabled)': {
                        color: designTokens.color.blue.default.value,
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=checkboxTheme.js.map